import React from 'react';
import StatusBadge from '@dashboard/components/StatusBadge';
import Tooltip from '@dashboard/components/Tooltip';
import getChargeStatusLabel from '@dashboard/services/status/getChargeStatusLabel';

function PaymentStatusBadge({ status, livemode, error }) {
  if (!livemode) {
    return <StatusBadge status="Test">Test</StatusBadge>;
  }

  const label = getChargeStatusLabel(status);

  if (error && status !== 'paid') {
    return (
      <Tooltip label={error} align="left">
        <StatusBadge status={status} label={label} withInfoIcon />
      </Tooltip>
    );
  }

  if (status === 'recovered') {
    return <StatusBadge status="recovered" label="Recovered" />;
  }

  if (status === 'abandoned') {
    return <StatusBadge status="abandoned" label="Abandoned" />;
  }

  if (status === 'complimentary') {
    return <StatusBadge status="complimentary" label="Comp" />;
  }

  return <StatusBadge status={status} label={label} />;
}

export default PaymentStatusBadge;
